// route level code-splitting
// this generates a separate chunk ([webpackChunkName].[hash].js) for the routes
// which is lazy-loaded when the route is visited.

import globalEditor from '@/router/globalEditor'
import * as loaded from '@/hooks/loaded'
import * as failed from '@/hooks/failed'
import localEditor from '@/router/localEditor'
import routeNames from '@/router/names'
import routeViews from '@/router/views'

export default [
  {
    path: '/editor',
    redirect: { name: routeNames.Create },
  },
  {
    path: '/editor/import',
    name: routeNames.Import,
    components: {
      [routeViews.Header]: () => import(/* webpackChunkName: "create" */ '../views/DefaultHeader/DefaultHeader.vue'),
      [routeViews.Main]: () => import(/* webpackChunkName: "create" */ '../views/ProfileCreator/ProfileImporter.vue'),
    },
    meta: {
      title: 'pb2.pageTitles.import',
      loaded: loaded.create,
      failed: failed.create,
    },
  },
  {
    path: '/editor/create/:profileUid?',
    name: routeNames.Create,
    components: {
      [routeViews.Header]: () => import(/* webpackChunkName: "create" */ '../views/DefaultHeader/DefaultHeader.vue'),
      [routeViews.Main]: () => import(/* webpackChunkName: "create" */ '../views/ProfileCreator/ProfileBasicData.vue'),
    },
    meta: {
      title: 'pb2.pageTitles.create',
      loaded: loaded.create,
      failed: failed.create,
    },
  },
  {
    path: '/editor/:profileUid',
    name: routeNames.Profile,
    redirect: { name: routeNames.Properties },
  },
  {
    path: '/editor/:profileUid/properties',
    name: routeNames.Properties,
    meta: {
      title: 'pb2.pageTitles.properties',
      loaded: loaded.editor,
      failed: failed.editor,
    },
    components: {
      [routeViews.Header]: () => import(/* webpackChunkName: "properties" */ '../views/ProfileEditor/ProfileHeader/ProfileHeader.vue'),
      [routeViews.Main]: () => import(/* webpackChunkName: "properties" */ '../views/ProfileEditor/ProfileProperties/ProfileProperties.vue'),
    },
  },
  {
    path: '/editor/:profileUid/content',
    name: routeNames.Content,
    redirect: { name: routeNames.Modes },
  },
  ...globalEditor,
  ...localEditor,
]
